import * as moment from 'moment';
import * as React from 'react';
import styled from 'styled-components';
import { IEvent } from 'types/events';

interface IProps {
  center?: boolean;
  selectable?: boolean;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
  event: IEvent;
}

export const EventRenderer: React.SFC<IProps> = props => {
  const getDate = (date: string) => {
    const m = moment.unix(parseInt(date, 10)).utc();
    return m.format('D MMM YYYY');
  };
  return (
    <Container
      selectable={props.selectable}
      className={props.className}
      // style={props.center ? { alignItems: 'initial' } : {}}
      onClick={props.onClick}
    >
      <City>{props.event.City}</City>
      <Item>{props.event.Country}</Item>
      <DateRow>{getDate(props.event.StartDate)}</DateRow>
      <DateRow>{getDate(props.event.EndDate)}</DateRow>
      <Level>{props.event.Level}</Level>
      <Item>{props.event.Venue}</Item>
    </Container>
  );
};

const Item = styled.td`
  padding: 10px;
  border-bottom: 1px solid black;
  border-collapse: collapse;
`;

const City = styled(Item)`
  width: 200px;
`;

const DateRow = styled(Item)`
  width: 170px;
`;

const Level = styled(Item)`
  width: 160px;
`;

const Container = styled.tr<{ selectable?: boolean }>``;

export default EventRenderer;



// WEBPACK FOOTER //
// ./src/components/EventRenderer/EventRenderer.tsx